import { Component, ViewChild } from '@angular/core';
import { ChargifyFormComponent } from '../chargify-form/chargify-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendAccessService } from '../../Services/APICalls/backend-access-service';
import { LoadingService } from '../../Services/Loading/loading-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-update-payment',
    templateUrl: './update-payment.component.html',
    styleUrls: ['./update-payment.component.scss'],
    standalone: false
})
/* istanbul ignore next */
export class UpdatePaymentComponent {
  @ViewChild(ChargifyFormComponent)
  chargifyFormComponent!: ChargifyFormComponent;
  chargifyToken: string = '';
  customerId: number | null = null;
  maxioSubId: string | null = null;
  isAch: boolean = false;
  achTermsAccepted: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly backend: BackendAccessService,
    private readonly router: Router,
    private readonly loading: LoadingService,
    private readonly snackBar: MatSnackBar
  ) {}
  /* istanbul ignore next */
  ngOnInit(): void {
    // Retrieve customerId and maxioSubId from query parameters
    this.route.queryParams.subscribe((params) => {
      this.customerId = params['customerId'] ? +params['customerId'] : null;
      this.maxioSubId = params['maxioSubId'] ?? null; // Retrieve maxioSubId
      console.log('Customer ID:', this.customerId);
      console.log('Subscription ID:', this.maxioSubId);
    });
  }
  /* istanbul ignore next */
  handlePaymentUpdate() {
    // Trigger the validation
    this.chargifyFormComponent.validateChargifyForm();
  }
  /* istanbul ignore next */
  onValidationSuccess(token: string) {
    this.loading.show();
    this.chargifyToken = token;
    console.log('Received token:', token);

    if (this.customerId && this.maxioSubId) {
      const payload = {
        chargifyToken: this.chargifyToken,
        customerId: this.customerId,
        subscriptionId: this.maxioSubId,
      };

      this.backend.addPaymentMethod(payload).subscribe({
        next: (response) => {
          console.log('Payment method updated successfully:', response);
          if (response.isSuccess) {
            this.showConfirmation(); // Show confirmation message
          } else {
            console.error('API responded with errors:', response.errors);
          }
        },
        error: (error) => {
          console.error('Error updating payment method:', error);
        },
      });
    } else {
      console.error('Customer ID or Subscription ID is missing');
    }
  }
  /* istanbul ignore next */
  showConfirmation() {
    this.snackBar.open('Payment method updated successfully!', 'Close', {
      duration: 3000, // Duration in milliseconds
    });

    // Navigate to the active subscription page after showing the message
    this.router.navigate(['/active-subscription'], {
      queryParams: { maxioSubId: this.maxioSubId },
    });
  }
  /* istanbul ignore next */
  onValidationFailure() {
    console.error('Chargify form validation failed.');
  }

  /* istanbul ignore next */
  navigateBack() {
    if (this.maxioSubId) {
      this.router.navigate(['/active-subscription'], {
        queryParams: { maxioSubId: this.maxioSubId },
      });
    } else {
      console.error('Subscription ID is missing');
    }
  }
  /* istanbul ignore next */
  onPaymentMethodChange(isAch: boolean) {
    this.isAch = isAch;
    console.log('Payment method changed. isAch:', this.isAch);
  }
  /* istanbul ignore next */
  onAchTermsAcceptedChange(status: boolean) {
    this.achTermsAccepted = status;
    console.log('ACH Terms Accepted:', this.achTermsAccepted);
  }
  /* istanbul ignore next */
  isUpdateButtonDisabled(): boolean {
    // Disable button if ACH is selected but terms not accepted
    return this.isAch && !this.achTermsAccepted;
  }
}
